import { GET_DUTYTYPE } from "../../resources/actionTypes";

const initialState = {
  dutyTypeList: [],
  loading: false,
  error: null,
};

export const userDutyType = (state = initialState, action) => {
  switch (action.type) {
    case GET_DUTYTYPE.GET_DUTYTYPE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DUTYTYPE.GET_DUTYTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        dutyTypeList: action.fetchDutyType
      };
    case GET_DUTYTYPE.GET_DUTYTYPE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};